import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase';
import { firestoreAction, vuexfireMutations } from 'vuexfire'
/*
import firebase from 'firebase/app'
import 'firebase/firestore'
*/
  // Your web app's Firebase configuration

  const db = firebase.firestore();
  const games = db.collection('games');
  const teams = db.collection('teams');
  const registration_to_game = db.collection('registration_to_game');
  const answers = db.collection('answers');
  const users = db.collection('users');
  //const unFinishedTodos = todos.where('finished', '==', false)
  //const finishedTodos = todos.where('finished', '==', true)
  //const currentTodos = finishedTodos
  const currentGame = db.collection('current').doc('1');

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    games: [],
    teams: [],
    registration_to_game: [],
    teamAnswers: [],
    gameAnswers: [],
    currentGame: {},
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    ...vuexfireMutations
  },
  getters: {
    logged: state => !!state.user,
    game: (state) => (id) =>  state.games && state.games.find(game => game.id == id),
    currentGame: state => state.currentGame || {},
    ifTeamRegisteredToGame: (state) => (team_id, game_id) => !!state.games.find(g => g.id == game_id)?.teams?.[team_id]
  },
  actions: {
    bindRef: firestoreAction(function(context, payload) {
      context.bindFirestoreRef(payload.name, payload.ref, payload.options)
    }),

    init: firestoreAction(function(context) {
      //context.bindFirestoreRef('users', db.collection('users'); //??
      context.unbindFirestoreRef('games');
      context.unbindFirestoreRef('teams');
      context.unbindFirestoreRef('registration_to_game');
      context.unbindFirestoreRef('currentGame');

      context.bindFirestoreRef('games', games); //db.collection('games')
      context.bindFirestoreRef('teams', teams);
      context.bindFirestoreRef('registration_to_game', registration_to_game);
      context.bindFirestoreRef('currentGame', currentGame);
    }),
    initCurrentUser: firestoreAction(function(context, userid) {
      console.log('initCurrentUser');
      context.unbindFirestoreRef('user');
      context.bindFirestoreRef('user', db.collection('users').doc(userid));
      //context.bindFirestoreRef('user', db.collection('users').doc(payload));
    }),
    deinitCurrentUser: firestoreAction((context) => {
      context.unbindFirestoreRef('user');      
      context.state.user = null;
    }),
    initGameAnswers: firestoreAction((context, game_id) => {
      context.unbindFirestoreRef('gameAnswers');
      context.bindFirestoreRef('gameAnswers', db.collection('answers').where('game_id', '==', game_id));
    }),
    initTeamAnswersForGame: firestoreAction((context, {team_id, game_id}) => {
      context.unbindFirestoreRef('teamAnswers');
      if(game_id && team_id) {
        context.bindFirestoreRef('teamAnswers', answers.where('game_id', '==', game_id).where('team_id', '==', team_id));
      }
    }),
    signup({commit}, {email, password}) {
      return firebase.auth().createUserWithEmailAndPassword(email, password)
        .then(user => {
          commit('setUser', user);
          return user;
        });
    },
    signin_facebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      // You can add additional scopes to the provider:
      provider.addScope('email');
      // Sign in with redirect:
      firebase.auth().signInWithRedirect(provider);
    },
    signin_google() {
      const provider = new firebase.auth.GoogleAuthProvider();
      // You can add additional scopes to the provider:
      provider.addScope('email');
      // Sign in with redirect:
      firebase.auth().signInWithRedirect(provider);
    },
    login({commit}, {email, password}) {
      return firebase.auth().signInWithEmailAndPassword(email, password).then(user => {
        commit('setUser', user);
        return user;
      })
    },
    logout({commit}) {
      return firebase.auth().signOut().then(() => commit("setUser", null));
    },
    createGame(_, gamedata) {
      console.log('createGame', gamedata);
      return games.add({...gamedata}).then(game => {
        console.log('created', {...game});
        return game.id;
      });
    },
    activateGame(_, {gameid, activate}) {
      if(activate) {
        return currentGame.update({gameid, round: 0, round_active: false})
      }
      return currentGame.update({gameid: null, round: 0, round_active: false});
    },
    nextRound({state}) {
      return currentGame.update({round: state.currentGame.round+1, round_active: false, deadline: null});
    },
    startRound() {
      return currentGame.update({round_active: true});
    },
    startCountdown() {
      const deadline = Math.round(Date.now() / 1000 + 60);
      return currentGame.update({deadline});
    },
    stopCountdown() {
      return currentGame.update({deadline: null, round_active: true});
    },
    addCurrentUserToTeam(_, team_id) {
      return users.doc(this.user.id).update({team_id}).catch(err => console.log('err adding team', err.message));
    },
    addCurrentUserToNewTeam({state}, team_name) {
      return teams.add({name: team_name})
        .then(team =>  users.doc(state.user.id).update({team_id: team.id}))
        .catch(err => console.log('err adding to new team', err.message));
    },
    registerToGame(_, {team_id, game_id}){
      return games.doc(game_id).get()
        .then((game) => {
          if(game.exists) {
            const gameTeams = game.data().teams || {};
            return games.doc(game_id).update({teams: {...gameTeams, [team_id]: team_id}});
          }
          throw Error('No such game');
        })
    },
    submitAnswers(_, answersObject) {
      return answers
        .where('game_id', '==', answersObject.game_id)
        .where('team_id', '==', answersObject.team_id)
        .where('round', '==', answersObject.round)
        .limit(1)
        .get()
        .then((game) => {
          if(game.empty || !game.docs[0].exists) {
            return answers.add(answersObject)
          } else {
            const answersFromFB = game.docs[0].data().answers || [];
            if(answersObject.answers && answersObject.answers.length > 0 &&
              (answersFromFB.length != answersObject.answers.length ||
              answersObject.answers.some((answer, idx) => answer != answersFromFB[idx]))
              ) {
                return answers.doc(game.docs[0].id).update(answersObject);
            }
            return false; //no need to save            
          }
        })
        .catch((err) => console.error('check existance answer error', err.message));
    },
    saveRoundScores(_, {game_id, team_id, round, score}) {
      const path = `scores.${team_id}.${round}`;
      console.log('saveRoundScores',game_id, team_id, round, score);
      return games.doc(game_id).update({[path]: score})
    }
  },
  modules: {
  },
});

export default store;